/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
	AddServiceContactsForMultipleClients,
	BulkAddServiceContact,
	ServiceContactResponse,
	ServiceContactWithDetailsEnumeration,
	UpdateServiceContact,
} from '../models/index';
import {
	AddServiceContactsForMultipleClientsFromJSON,
	AddServiceContactsForMultipleClientsToJSON,
	BulkAddServiceContactFromJSON,
	BulkAddServiceContactToJSON,
	ServiceContactResponseFromJSON,
	ServiceContactResponseToJSON,
	ServiceContactWithDetailsEnumerationFromJSON,
	ServiceContactWithDetailsEnumerationToJSON,
	UpdateServiceContactFromJSON,
	UpdateServiceContactToJSON,
} from '../models/index';

export interface AddServiceContactsForMultipleClientsRequest {
	xBffCsrf?: string;
	addServiceContactsForMultipleClients?: AddServiceContactsForMultipleClients;
}

export interface BulkAddServiceContactsRequest {
	encodedClientRID: string;
	xBffCsrf?: string;
	bulkAddServiceContact?: BulkAddServiceContact;
}

export interface GetServiceContactRequest {
	encodedClientRID: string;
	encodedActorRID: string;
	xBffCsrf?: string;
}

export interface GetServiceContactsRequest {
	encodedClientRID: string;
	xBffCsrf?: string;
}

export interface RemoveServiceContactRequest {
	encodedClientRID: string;
	encodedActorRID: string;
	xBffCsrf?: string;
}

export interface ReplaceServiceContactMetadataRequest {
	encodedClientRID: string;
	encodedActorRID: string;
	xBffCsrf?: string;
	body?: object;
}

export interface UpdateServiceContactRequest {
	encodedClientRID: string;
	encodedActorRID: string;
	xBffCsrf?: string;
	updateServiceContact?: UpdateServiceContact;
}

/**
 * ServiceContactsApi - interface
 *
 * @export
 * @interface ServiceContactsApiInterface
 */
export interface ServiceContactsApiInterface {
	/**
	 * Endpoint adds the listed service contacts to the listed client organizations. If the service contact already exists on the client as same type (primary, unknown), then it will be ignored. Any existing unknown service contacts will be upgraded to primary if requested. If the service contact does not have actorRID then it will try to fetch the employee with email, otherwise create a new employee in v3. Requires client_servicecontact:create permission.
	 * @summary Add multiple service contacts to multiple clients
	 * @param {string} [xBffCsrf]
	 * @param {AddServiceContactsForMultipleClients} [addServiceContactsForMultipleClients] Payload to add multiple service contacts to multiple client organizations
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ServiceContactsApiInterface
	 */
	addServiceContactsForMultipleClientsRaw(
		requestParameters: AddServiceContactsForMultipleClientsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>>;

	/**
	 * Endpoint adds the listed service contacts to the listed client organizations. If the service contact already exists on the client as same type (primary, unknown), then it will be ignored. Any existing unknown service contacts will be upgraded to primary if requested. If the service contact does not have actorRID then it will try to fetch the employee with email, otherwise create a new employee in v3. Requires client_servicecontact:create permission.
	 * Add multiple service contacts to multiple clients
	 */
	addServiceContactsForMultipleClients(
		requestParameters: AddServiceContactsForMultipleClientsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void>;

	/**
	 * Endpoint adds multiple service contacts to a client organization. If the service contact does not have actorRID then it will try to fetch the employee with email, otherwise create a new employee in v3. Requires client_servicecontact:create permission.
	 * @summary Add multiple service contacts
	 * @param {string} encodedClientRID
	 * @param {string} [xBffCsrf]
	 * @param {BulkAddServiceContact} [bulkAddServiceContact] Payload to add multiple service contacts to a client organization
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ServiceContactsApiInterface
	 */
	bulkAddServiceContactsRaw(
		requestParameters: BulkAddServiceContactsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ServiceContactWithDetailsEnumeration>>;

	/**
	 * Endpoint adds multiple service contacts to a client organization. If the service contact does not have actorRID then it will try to fetch the employee with email, otherwise create a new employee in v3. Requires client_servicecontact:create permission.
	 * Add multiple service contacts
	 */
	bulkAddServiceContacts(
		requestParameters: BulkAddServiceContactsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ServiceContactWithDetailsEnumeration>;

	/**
	 * Get a service contact by the client RID and actor RID. Requires client_servicecontact:read permission.
	 * @summary Get service contact for a client organization
	 * @param {string} encodedClientRID
	 * @param {string} encodedActorRID
	 * @param {string} [xBffCsrf]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ServiceContactsApiInterface
	 */
	getServiceContactRaw(
		requestParameters: GetServiceContactRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ServiceContactResponse>>;

	/**
	 * Get a service contact by the client RID and actor RID. Requires client_servicecontact:read permission.
	 * Get service contact for a client organization
	 */
	getServiceContact(
		requestParameters: GetServiceContactRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ServiceContactResponse>;

	/**
	 * Get a list of service contacts for a client. Requires client_servicecontact:read permission on each service contact.
	 * @summary List service contacts
	 * @param {string} encodedClientRID
	 * @param {string} [xBffCsrf]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ServiceContactsApiInterface
	 */
	getServiceContactsRaw(
		requestParameters: GetServiceContactsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ServiceContactWithDetailsEnumeration>>;

	/**
	 * Get a list of service contacts for a client. Requires client_servicecontact:read permission on each service contact.
	 * List service contacts
	 */
	getServiceContacts(
		requestParameters: GetServiceContactsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ServiceContactWithDetailsEnumeration>;

	/**
	 * Remove a service contact from a client organization. Requires client_servicecontact:delete permission.
	 * @summary Remove a service contact
	 * @param {string} encodedClientRID
	 * @param {string} encodedActorRID
	 * @param {string} [xBffCsrf]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ServiceContactsApiInterface
	 */
	removeServiceContactRaw(
		requestParameters: RemoveServiceContactRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>>;

	/**
	 * Remove a service contact from a client organization. Requires client_servicecontact:delete permission.
	 * Remove a service contact
	 */
	removeServiceContact(
		requestParameters: RemoveServiceContactRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void>;

	/**
	 * Replaces a service contact\'s metadata. Requires client_servicecontact:modify permission.
	 * @summary Replace service contact metadata
	 * @param {string} encodedClientRID
	 * @param {string} encodedActorRID
	 * @param {string} [xBffCsrf]
	 * @param {object} [body]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ServiceContactsApiInterface
	 */
	replaceServiceContactMetadataRaw(
		requestParameters: ReplaceServiceContactMetadataRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>>;

	/**
	 * Replaces a service contact\'s metadata. Requires client_servicecontact:modify permission.
	 * Replace service contact metadata
	 */
	replaceServiceContactMetadata(
		requestParameters: ReplaceServiceContactMetadataRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void>;

	/**
	 * Update the service contact in a client organization. Requires client_servicecontact:modify permission.
	 * @summary Update service contact
	 * @param {string} encodedClientRID
	 * @param {string} encodedActorRID
	 * @param {string} [xBffCsrf]
	 * @param {UpdateServiceContact} [updateServiceContact] Payload to update the service contact in a client organization
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ServiceContactsApiInterface
	 */
	updateServiceContactRaw(
		requestParameters: UpdateServiceContactRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>>;

	/**
	 * Update the service contact in a client organization. Requires client_servicecontact:modify permission.
	 * Update service contact
	 */
	updateServiceContact(
		requestParameters: UpdateServiceContactRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void>;
}

/**
 *
 */
export class ServiceContactsApi
	extends runtime.BaseAPI
	implements ServiceContactsApiInterface
{
	/**
	 * Endpoint adds the listed service contacts to the listed client organizations. If the service contact already exists on the client as same type (primary, unknown), then it will be ignored. Any existing unknown service contacts will be upgraded to primary if requested. If the service contact does not have actorRID then it will try to fetch the employee with email, otherwise create a new employee in v3. Requires client_servicecontact:create permission.
	 * Add multiple service contacts to multiple clients
	 */
	async addServiceContactsForMultipleClientsRaw(
		requestParameters: AddServiceContactsForMultipleClientsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>> {
		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
					'clientmanagement:activity.write',
					'clientmanagement:serviceteam.read',
					'clientmanagement:serviceteam.write',
					'clientmanagement:serviceteam.delete',
				]
			);
		}

		const response = await this.request(
			{
				path: `/clients/serviceContacts`,
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: AddServiceContactsForMultipleClientsToJSON(
					requestParameters.addServiceContactsForMultipleClients
				),
			},
			initOverrides
		);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 * Endpoint adds the listed service contacts to the listed client organizations. If the service contact already exists on the client as same type (primary, unknown), then it will be ignored. Any existing unknown service contacts will be upgraded to primary if requested. If the service contact does not have actorRID then it will try to fetch the employee with email, otherwise create a new employee in v3. Requires client_servicecontact:create permission.
	 * Add multiple service contacts to multiple clients
	 */
	async addServiceContactsForMultipleClients(
		requestParameters: AddServiceContactsForMultipleClientsRequest = {},
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void> {
		await this.addServiceContactsForMultipleClientsRaw(requestParameters, initOverrides);
	}

	/**
	 * Endpoint adds multiple service contacts to a client organization. If the service contact does not have actorRID then it will try to fetch the employee with email, otherwise create a new employee in v3. Requires client_servicecontact:create permission.
	 * Add multiple service contacts
	 */
	async bulkAddServiceContactsRaw(
		requestParameters: BulkAddServiceContactsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ServiceContactWithDetailsEnumeration>> {
		if (
			requestParameters.encodedClientRID === null ||
			requestParameters.encodedClientRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedClientRID',
				'Required parameter requestParameters.encodedClientRID was null or undefined when calling bulkAddServiceContacts.'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
					'clientmanagement:activity.write',
					'clientmanagement:serviceteam.read',
					'clientmanagement:serviceteam.write',
					'clientmanagement:serviceteam.delete',
				]
			);
		}

		const response = await this.request(
			{
				path: `/clients/{encodedClientRID}/bulkServiceContacts`.replace(
					`{${'encodedClientRID'}}`,
					encodeURIComponent(String(requestParameters.encodedClientRID))
				),
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: BulkAddServiceContactToJSON(requestParameters.bulkAddServiceContact),
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			ServiceContactWithDetailsEnumerationFromJSON(jsonValue)
		);
	}

	/**
	 * Endpoint adds multiple service contacts to a client organization. If the service contact does not have actorRID then it will try to fetch the employee with email, otherwise create a new employee in v3. Requires client_servicecontact:create permission.
	 * Add multiple service contacts
	 */
	async bulkAddServiceContacts(
		requestParameters: BulkAddServiceContactsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ServiceContactWithDetailsEnumeration> {
		const response = await this.bulkAddServiceContactsRaw(
			requestParameters,
			initOverrides
		);
		return await response.value();
	}

	/**
	 * Get a service contact by the client RID and actor RID. Requires client_servicecontact:read permission.
	 * Get service contact for a client organization
	 */
	async getServiceContactRaw(
		requestParameters: GetServiceContactRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ServiceContactResponse>> {
		if (
			requestParameters.encodedClientRID === null ||
			requestParameters.encodedClientRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedClientRID',
				'Required parameter requestParameters.encodedClientRID was null or undefined when calling getServiceContact.'
			);
		}

		if (
			requestParameters.encodedActorRID === null ||
			requestParameters.encodedActorRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedActorRID',
				'Required parameter requestParameters.encodedActorRID was null or undefined when calling getServiceContact.'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
					'clientmanagement:activity.write',
					'clientmanagement:serviceteam.read',
					'clientmanagement:serviceteam.write',
					'clientmanagement:serviceteam.delete',
				]
			);
		}

		const response = await this.request(
			{
				path: `/clients/{encodedClientRID}/serviceContacts/{encodedActorRID}`
					.replace(
						`{${'encodedClientRID'}}`,
						encodeURIComponent(String(requestParameters.encodedClientRID))
					)
					.replace(
						`{${'encodedActorRID'}}`,
						encodeURIComponent(String(requestParameters.encodedActorRID))
					),
				method: 'GET',
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			ServiceContactResponseFromJSON(jsonValue)
		);
	}

	/**
	 * Get a service contact by the client RID and actor RID. Requires client_servicecontact:read permission.
	 * Get service contact for a client organization
	 */
	async getServiceContact(
		requestParameters: GetServiceContactRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ServiceContactResponse> {
		const response = await this.getServiceContactRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Get a list of service contacts for a client. Requires client_servicecontact:read permission on each service contact.
	 * List service contacts
	 */
	async getServiceContactsRaw(
		requestParameters: GetServiceContactsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ServiceContactWithDetailsEnumeration>> {
		if (
			requestParameters.encodedClientRID === null ||
			requestParameters.encodedClientRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedClientRID',
				'Required parameter requestParameters.encodedClientRID was null or undefined when calling getServiceContacts.'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
					'clientmanagement:activity.write',
					'clientmanagement:serviceteam.read',
					'clientmanagement:serviceteam.write',
					'clientmanagement:serviceteam.delete',
				]
			);
		}

		const response = await this.request(
			{
				path: `/clients/{encodedClientRID}/serviceContacts`.replace(
					`{${'encodedClientRID'}}`,
					encodeURIComponent(String(requestParameters.encodedClientRID))
				),
				method: 'GET',
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			ServiceContactWithDetailsEnumerationFromJSON(jsonValue)
		);
	}

	/**
	 * Get a list of service contacts for a client. Requires client_servicecontact:read permission on each service contact.
	 * List service contacts
	 */
	async getServiceContacts(
		requestParameters: GetServiceContactsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ServiceContactWithDetailsEnumeration> {
		const response = await this.getServiceContactsRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Remove a service contact from a client organization. Requires client_servicecontact:delete permission.
	 * Remove a service contact
	 */
	async removeServiceContactRaw(
		requestParameters: RemoveServiceContactRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>> {
		if (
			requestParameters.encodedClientRID === null ||
			requestParameters.encodedClientRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedClientRID',
				'Required parameter requestParameters.encodedClientRID was null or undefined when calling removeServiceContact.'
			);
		}

		if (
			requestParameters.encodedActorRID === null ||
			requestParameters.encodedActorRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedActorRID',
				'Required parameter requestParameters.encodedActorRID was null or undefined when calling removeServiceContact.'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
					'clientmanagement:activity.write',
					'clientmanagement:serviceteam.read',
					'clientmanagement:serviceteam.write',
					'clientmanagement:serviceteam.delete',
				]
			);
		}

		const response = await this.request(
			{
				path: `/clients/{encodedClientRID}/serviceContacts/{encodedActorRID}`
					.replace(
						`{${'encodedClientRID'}}`,
						encodeURIComponent(String(requestParameters.encodedClientRID))
					)
					.replace(
						`{${'encodedActorRID'}}`,
						encodeURIComponent(String(requestParameters.encodedActorRID))
					),
				method: 'DELETE',
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 * Remove a service contact from a client organization. Requires client_servicecontact:delete permission.
	 * Remove a service contact
	 */
	async removeServiceContact(
		requestParameters: RemoveServiceContactRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void> {
		await this.removeServiceContactRaw(requestParameters, initOverrides);
	}

	/**
	 * Replaces a service contact\'s metadata. Requires client_servicecontact:modify permission.
	 * Replace service contact metadata
	 */
	async replaceServiceContactMetadataRaw(
		requestParameters: ReplaceServiceContactMetadataRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>> {
		if (
			requestParameters.encodedClientRID === null ||
			requestParameters.encodedClientRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedClientRID',
				'Required parameter requestParameters.encodedClientRID was null or undefined when calling replaceServiceContactMetadata.'
			);
		}

		if (
			requestParameters.encodedActorRID === null ||
			requestParameters.encodedActorRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedActorRID',
				'Required parameter requestParameters.encodedActorRID was null or undefined when calling replaceServiceContactMetadata.'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
					'clientmanagement:activity.write',
					'clientmanagement:serviceteam.read',
					'clientmanagement:serviceteam.write',
					'clientmanagement:serviceteam.delete',
				]
			);
		}

		const response = await this.request(
			{
				path: `/clients/{encodedClientRID}/serviceContacts/{encodedActorRID}/metadata`
					.replace(
						`{${'encodedClientRID'}}`,
						encodeURIComponent(String(requestParameters.encodedClientRID))
					)
					.replace(
						`{${'encodedActorRID'}}`,
						encodeURIComponent(String(requestParameters.encodedActorRID))
					),
				method: 'PUT',
				headers: headerParameters,
				query: queryParameters,
				body: requestParameters.body as any,
			},
			initOverrides
		);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 * Replaces a service contact\'s metadata. Requires client_servicecontact:modify permission.
	 * Replace service contact metadata
	 */
	async replaceServiceContactMetadata(
		requestParameters: ReplaceServiceContactMetadataRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void> {
		await this.replaceServiceContactMetadataRaw(requestParameters, initOverrides);
	}

	/**
	 * Update the service contact in a client organization. Requires client_servicecontact:modify permission.
	 * Update service contact
	 */
	async updateServiceContactRaw(
		requestParameters: UpdateServiceContactRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>> {
		if (
			requestParameters.encodedClientRID === null ||
			requestParameters.encodedClientRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedClientRID',
				'Required parameter requestParameters.encodedClientRID was null or undefined when calling updateServiceContact.'
			);
		}

		if (
			requestParameters.encodedActorRID === null ||
			requestParameters.encodedActorRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedActorRID',
				'Required parameter requestParameters.encodedActorRID was null or undefined when calling updateServiceContact.'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
					'clientmanagement:activity.write',
					'clientmanagement:serviceteam.read',
					'clientmanagement:serviceteam.write',
					'clientmanagement:serviceteam.delete',
				]
			);
		}

		const response = await this.request(
			{
				path: `/clients/{encodedClientRID}/serviceContacts/{encodedActorRID}`
					.replace(
						`{${'encodedClientRID'}}`,
						encodeURIComponent(String(requestParameters.encodedClientRID))
					)
					.replace(
						`{${'encodedActorRID'}}`,
						encodeURIComponent(String(requestParameters.encodedActorRID))
					),
				method: 'PUT',
				headers: headerParameters,
				query: queryParameters,
				body: UpdateServiceContactToJSON(requestParameters.updateServiceContact),
			},
			initOverrides
		);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 * Update the service contact in a client organization. Requires client_servicecontact:modify permission.
	 * Update service contact
	 */
	async updateServiceContact(
		requestParameters: UpdateServiceContactRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void> {
		await this.updateServiceContactRaw(requestParameters, initOverrides);
	}
}
